<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    const expiresAt = localStorage.getItem("expiresAt");
    if (expiresAt) {
      if (new Date().getTime() > expiresAt) {
        this.toastMessage("Session expired. Please log in again.", "info");
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style lang="scss">
.card-container {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 49% 49%;
}
</style>
